import { ContractFeatures, ModuleType, TokenMetadata, TokenRarity, TokenType } from "@framework/types";
import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { FormGrid } from "@dzambalaorg/ui-kit";

interface ITokenSearchFormProps {
  contractType: Array<TokenType>;
  contractModule: Array<ModuleType>;
  contractFeatures?: Array<ContractFeatures>;
}

const initialValues = {
  contractIds: [],
  [`metadata.${TokenMetadata.RARITY}`]: [],
  [`metadata.${TokenMetadata.LEVEL}`]: [],
};

export const TokenSearchForm = (props: ITokenSearchFormProps) => {
  const { contractType, contractModule, contractFeatures } = props;

  const isMetadataFields =
    contractType.filter(value => [TokenType.ERC721, TokenType.ERC998].includes(value)).length &&
    contractModule.filter(value => [ModuleType.HIERARCHY].includes(value)).length;

  return (
    <SearchWithFilters initialValues={initialValues} chipsKeys={[`metadata.${TokenMetadata.RARITY}`]}>
      <FormGrid columns={!isMetadataFields ? [1] : [1, 1]}>
        <EntityInput
          name="contractIds"
          controller="contracts"
          multiple
          fetchData={{ contractType, contractModule, contractFeatures }}
        />
        {isMetadataFields && (
          <FormGrid columns={[2]}>
            <SelectInput name={`metadata.${TokenMetadata.RARITY}`} options={TokenRarity} multiple />
            <SelectInput
              name={`metadata.${TokenMetadata.LEVEL}`}
              options={new Array(10)
                .fill(null)
                .reduce((memo: Record<string, string>, value, i) => Object.assign(memo, { [i + 1]: i + 1 }), {})}
              multiple
            />
          </FormGrid>
        )}
      </FormGrid>
    </SearchWithFilters>
  );
};
